"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("./object");
var mobx_1 = require("mobx");
var core_1 = require("../../core");
var utils_1 = require("../../utils");
var type_1 = require("../type");
var type_checker_1 = require("../type-checker");
var complex_type_1 = require("./complex-type");
function mapToString() {
    return core_1.getMSTAdministration(this) + "(" + this.size + " items)";
}
exports.mapToString = mapToString;
function put(value) {
    var identifierAttr = object_1.getIdentifierAttribute(core_1.getMSTAdministration(this).type.subType);
    utils_1.invariant(!!identifierAttr, "Map.put is only supported if the subtype has an idenfier attribute");
    utils_1.invariant(!!value, "Map.put cannot be used to set empty values");
    this.set(value[identifierAttr], value);
    return this;
}
var MapType = (function (_super) {
    __extends(MapType, _super);
    function MapType(name, subType) {
        var _this = _super.call(this, name) || this;
        _this.isMapFactory = true;
        _this.subType = subType;
        return _this;
    }
    MapType.prototype.describe = function () {
        return "Map<string, " + this.subType.describe() + ">";
    };
    MapType.prototype.createNewInstance = function () {
        // const identifierAttr = getIdentifierAttribute(this.subType)
        var map = mobx_1.observable.shallowMap();
        utils_1.addHiddenFinalProp(map, "put", put);
        utils_1.addHiddenFinalProp(map, "toString", mapToString);
        return map;
    };
    MapType.prototype.finalizeNewInstance = function (instance, snapshot) {
        var _this = this;
        mobx_1.intercept(instance, function (c) { return _this.willChange(c); });
        mobx_1.observe(instance, this.didChange);
        core_1.getMSTAdministration(instance).applySnapshot(snapshot);
    };
    MapType.prototype.getChildMSTs = function (node) {
        var res = [];
        node.target.forEach(function (value, key) {
            core_1.maybeMST(value, function (childNode) { res.push([key, childNode]); });
        });
        return res;
    };
    MapType.prototype.getChildMST = function (node, key) {
        var target = node.target;
        if (target.has(key))
            return core_1.maybeMST(target.get(key), utils_1.identity, utils_1.nothing);
        return null;
    };
    MapType.prototype.willChange = function (change) {
        var node = core_1.getMSTAdministration(change.object);
        node.assertWritable();
        // Q: how to create a map that is not keyed by identifier, but contains objects with identifiers? Is that a use case? A: No, that is were reference maps should come into play...
        var identifierAttr = object_1.getIdentifierAttribute(node.type);
        if (identifierAttr && change.newValue && typeof change.newValue === "object" && change.newValue[identifierAttr] !== change.name)
            utils_1.fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + change.name + "', but expected: '" + change.newValue[identifierAttr] + "'");
        switch (change.type) {
            case "update":
                {
                    var newValue = change.newValue;
                    var oldValue = change.object.get(change.name);
                    if (newValue === oldValue)
                        return null;
                    change.newValue = node.reconcileChildren(this.subType, [oldValue], [newValue], [change.name])[0];
                }
                break;
            case "add":
                {
                    var newValue = change.newValue;
                    change.newValue = node.reconcileChildren(this.subType, [], [newValue], [change.name])[0];
                }
                break;
            case "delete":
                {
                    var oldValue = change.object.get(change.name);
                    node.reconcileChildren(this.subType, [oldValue], [], []);
                }
                break;
        }
        return change;
    };
    MapType.prototype.serialize = function (node) {
        var target = node.target;
        var res = {};
        target.forEach(function (value, key) {
            res[key] = core_1.valueToSnapshot(value);
        });
        return res;
    };
    MapType.prototype.didChange = function (change) {
        var node = core_1.getMSTAdministration(change.object);
        switch (change.type) {
            case "update":
            case "add":
                return void node.emitPatch({
                    op: change.type === "add" ? "add" : "replace",
                    path: core_1.escapeJsonPath(change.name),
                    value: core_1.valueToSnapshot(change.newValue)
                }, node);
            case "delete":
                return void node.emitPatch({
                    op: "remove",
                    path: core_1.escapeJsonPath(change.name)
                }, node);
        }
    };
    MapType.prototype.applyPatchLocally = function (node, subpath, patch) {
        var target = node.target;
        switch (patch.op) {
            case "add":
            case "replace":
                target.set(subpath, patch.value);
                break;
            case "remove":
                target.delete(subpath);
                break;
        }
    };
    MapType.prototype.applySnapshot = function (node, snapshot) {
        var _this = this;
        node.pseudoAction(function () {
            var target = node.target;
            var identifierAttr = object_1.getIdentifierAttribute(_this.subType);
            // Try to update snapshot smartly, by reusing instances under the same key as much as possible
            var currentKeys = {};
            target.keys().forEach(function (key) { currentKeys[key] = false; });
            Object.keys(snapshot).forEach(function (key) {
                var item = snapshot[key];
                if (identifierAttr && item && typeof item === "object" && key !== item[identifierAttr])
                    utils_1.fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + key + "', but expected: '" + item[identifierAttr] + "'");
                // if snapshot[key] is non-primitive, and this.get(key) has a Node, update it, instead of replace
                if (key in currentKeys && !utils_1.isPrimitive(item)) {
                    currentKeys[key] = true;
                    core_1.maybeMST(target.get(key), function (propertyNode) {
                        // update existing instance
                        propertyNode.applySnapshot(item);
                    }, function () {
                        target.set(key, item);
                    });
                }
                else {
                    target.set(key, item);
                }
            });
            Object.keys(currentKeys).forEach(function (key) {
                if (currentKeys[key] === false)
                    target.delete(key);
            });
        });
    };
    MapType.prototype.getChildType = function (key) {
        return this.subType;
    };
    MapType.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        if (!utils_1.isPlainObject(value)) {
            return type_checker_1.typeCheckFailure(context, value);
        }
        return type_checker_1.flattenTypeErrors(Object.keys(value).map(function (path) { return _this.subType.validate(value[path], type_checker_1.getContextForPath(context, path, _this.subType)); }));
    };
    MapType.prototype.getDefaultSnapshot = function () {
        return {};
    };
    MapType.prototype.removeChild = function (node, subpath) {
        node.target.delete(subpath);
    };
    Object.defineProperty(MapType.prototype, "identifierAttribute", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return MapType;
}(complex_type_1.ComplexType));
__decorate([
    mobx_1.action
], MapType.prototype, "applySnapshot", null);
exports.MapType = MapType;
function map(subtype) {
    return new MapType("map<string, " + subtype.name + ">", subtype);
}
exports.map = map;
function isMapFactory(factory) {
    return type_1.isType(factory) && factory.isMapFactory === true;
}
exports.isMapFactory = isMapFactory;
//# sourceMappingURL=map.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/complex-types/map.js
// module id = 217
// module chunks = 0